export default __webpack_public_path__ + "static/media/1.508b804a.gif";